import { TabbedItemPage } from './TabbedItemPage';

export const StpSetupPage = () => <TabbedItemPage itemPath="/maintenance/stp-setup" />;
